// extracted by mini-css-extract-plugin
export default {"footer":"Questionary_footer__4ZQWy","badge":"Questionary_badge__oHpdO"};